<!-- Stays clickable above open modals (see ModalService.syncInert). -->
<app-notification-toast data-modal-keep-interactive />
<router-outlet />
